import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { createTheme, ThemeProvider } from '@mui/material';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import ErrorPage from './error-page';
import OrderPage from './pages/order-page';
import PaymentPage from './pages/payment-page';

const theme = createTheme({
    palette: {
        primary: {
            main: "#09382b",
        },
        secondary: {
            main: "#f6a320",
        },
    },
});

const router = createBrowserRouter([
    {
        path: "/",
        element: <App />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: "",
                element: <OrderPage />,
            },
            {
                path: "/payment",
                element: <PaymentPage />
            },
        ],
    },
]);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <ThemeProvider theme={theme}>
        <RouterProvider router={router} />
    </ThemeProvider>
);

